import AttendanceAdapter from './base';

export default class SickbayVisit extends AttendanceAdapter {
  modelNamePlural = 'sickbayVisits';
}
